import React from 'react';

// Local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { overlay } from 'modules/overlay';

//import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsSavingsAlternateDrugsWidgetSuccess as MemberDetailsSavingsAlternateDrugsWidgetSuccess } from 'ui/views/widgets/memberDetailsSavingsAlternateDrugsWidget';
 *
 * // render
 * <MemberDetailsSavingsAlternateDrugsWidgetSuccess propName='propValue'/>
 */
const memberDetailsSavingsAlternateDrugsWidgetSuccess = ( props ) => {

    return (
        <div className='ui-member-details-savings-alternate-drugs-widget'>

            <div className='ui-alternate-drugs__header'>

                {/* title for the modal */}
                <div className='ui-alternate-drugs__header__title'>
                    { getLabel( props.title ) }
                </div>
                
                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => overlay.close() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

            {/* <TabSelectionWidgets tabs = { tabsComp } default={ defaultTab }/> */}

            <WidgetsTabFlow
                className = 'ui-alternate-drugs__content'
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
            />
        </div>
    );
};

// set display name
memberDetailsSavingsAlternateDrugsWidgetSuccess.displayName = 'memberDetailsSavingsAlternateDrugsWidget';

// set default props
memberDetailsSavingsAlternateDrugsWidgetSuccess.defaultProps = {
    requestPayload: {},
};

// prop types
memberDetailsSavingsAlternateDrugsWidgetSuccess.propTypes = {};

//  *****************************************************


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsSavingsAlternateDrugsWidget as MemberDetailsSavingsAlternateDrugsWidget } from 'ui/views/widgets/memberDetailsSavingsAlternateDrugsWidget';
 *
 * // render
 * <memberDetailsSavingsAlternateDrugsWidget propName='propValue'/>
 */
export const memberDetailsSavingsAlternateDrugsWidget = withNetworkState( memberDetailsSavingsAlternateDrugsWidgetSuccess );
